import { useTranslation } from "react-i18next";
import FullModal from "../../../components/modal/full.modal";
import Icon from "../../../components/element/icon";
import IdentityDetailsModal from "./identity.details.modal";
import InsuranceRequestModal from "./insurance.request.modal";
import VsoSigning from "../components/vso.signing";

export default function PurchaseStepReviewModal({ step, purchase, onClose }) {
  const { t } = useTranslation();
  const props = { readOnly: true, initialData: step.data, documents: step.documents, onClose };
  if (step.number === 1) return <IdentityDetailsModal {...props} />;
  if (step.number === 3) return <InsuranceRequestModal {...props} />;
  const signedVso = step.documents.find((document) => document.group === "vso_with_sign");
  return (
    <FullModal independent show close={onClose} centered screenSize="xl"
      className="purchase-form-modal"
      dialogClassName="purchase-form-modal-dialog vso-review-modal-dialog"
      contentClassName="purchase-form-modal-content"
      content={
        <section className="purchase-form-dialog purchase-form-readonly">
          <header className="purchase-form-header">
            <button className="purchase-modal-back" type="button" onClick={onClose} aria-label="Close review">
              <Icon icon="ep:back" />
            </button>
            <h1 className="_label purchase-form-title">{t(step.title)}</h1>
          </header>
          <p className="purchase-review-note"><Icon icon="solar:lock-keyhole-linear" /> {t("Submitted · View only")}</p>
          {step.data.buyer_type && <p className="purchase-review-note">{t("Purchase Method:")} {t(step.data.buyer_type === "cash" ? "Cash Buy" : step.data.buyer_type === "loan" ? "Apply Loan" : step.data.buyer_type)}</p>}
          <VsoSigning readOnly purchase={purchase} initialData={step.data}
            documentOnly={Boolean(signedVso)}
            document={signedVso || step.documents.find((document) => ["vso", "vso_document"].includes(document.group))}
            signatureDocument={step.documents.find((document) => document.group === "signature_image")}
          />
        </section>
      }
    />
  );
}
